<template>
    <div id="securityInformationProfessional">
        <div class="container down white zIndexTwo">
            <div class="row m-0 pl-md-5 pr-md-5 ">
                <div class="col-lg-6 text-left pb-5">
                    <h1 class="pt-5 pb-5">Bepaal je eigen tarief <br />en je eigen werkgebied.</h1>
                    <p>Vind opdrachten, altijd zeker van je betaling of je nou in loondienst of als freelancer werkt.</p>
                    <p class="mb-5">Naast <router-link tag="a" :to="{ name: 'InformationSecurity'}">beveiliger</router-link>, kunt u zich hier ook aanmelden als <router-link tag="a" :to="{ name: 'InformationTrafficSupport'}">verkeersregelaar</router-link>, brandwacht en/of <router-link tag="a" :to="{ name: 'InformationFirstAid'}">EHBO-er</router-link>.</p>
                    <router-link :to="{ name: 'RegisterProfessional' }" tag="button" class="btn btn-outline-azure btn-half mb-3">
                        <span>Aanmelden als <br /> beveiliger</span>
                        <div class="btn-icon">
                            <span>&rarr;</span>
                        </div>
                    </router-link>
                </div>
                <div class="col-lg-6 pl-md-5 pr-md-5 text-center mb-5">
                    <img src="@/assets/guard-600.webp" class="img-fluid" alt="Azurity Beveiliging" />
                </div>
            </div>
        </div>
        <div class="row bg-azure-light m-0 p-5 down light zIndexOne">
            <div class="col-md-4 text-center vert-center order-md-2 mt-5 mb-5 mt-md-0 mb-md-0">
                <font-awesome-icon icon="euro-sign" size="7x"  />
            </div>
            <div class="col-md-4 offset-md-2 text-left order-md-1">
                <h3>Flexibel Tarief</h3>
                <p>Door een slimme kalender bepaal je als beveiliger zelf op welke dag je hoeveel wilt verdienen. Daarnaast hanteren wij een standaard <strong>betalingstermijn van 2 werkdagen</strong> na het voltooien van de opdracht.</p>
            </div>
        </div>
        <div class="row m-0 p-5 down white zIndexThree">
            <div class="col-md-4 offset-md-2 text-center vert-center mt-5 mb-5 mt-md-0 mb-md-0">
                <provinces></provinces>
            </div>
            <div class="col-md-4 text-left">
                <h3>Werkgebied</h3>
                <p>Je kunt zelf bepalen in welke regio's je gevonden wilt worden en wilt werken.</p>
            </div>
        </div>
        <div class="row bg-azure-light m-0 p-5 down light zIndexTwo demo-height">
            <div class="col-md-4 text-center vert-center order-md-2 mt-5 mb-5 mt-md-0 mb-md-0 demo">
                <calendar :demo="true" ></calendar>
            </div>
            <div class="col-md-4 offset-md-2 text-left order-md-1">
                <h3>Slimme Kalender</h3>
                <p>Met behulp van de slimme kalender kun je direct je beschikbaarheid bepalen en per dag een ander tarief instellen dan je standaard tarief.</p>
                <div class="text-center">
                    <a href="mailto:info@azurity.nl?subject=Demo Aanvraag" class="btn btn-azure-dark">Demo Aanvragen</a>
                </div>
            </div>
        </div>
        <div class="row m-0 p-5 light zIndexOne">
            <div class="col-md-4 offset-md-2 text-center vert-center mt-5 mb-5 mt-md-0 mb-md-0">
                <font-awesome-icon icon="file-signature" size="7x"  />
            </div>
            <div class="col-md-4 text-left">
                <h3>Contract</h3>
                <p>Bij ons bent u niet gebonden aan een contract bij Azurity, maar kunt u ook opdrachten voor uw huidige werkgever invullen, IB47 of als ZZP-er aan de slag.</p>
            </div>
        </div>
    </div>
</template>

<script>
import Provinces from '@/components/Map'
import Calendar from '@/components/Calendar'

export default {
    components: {
        Provinces,
        Calendar
    }
}
</script>

<style scoped lang="scss">
#map {
    width: 100px;
}


.demo {
    -webkit-transform:scale(0.2);
    -moz-transform:scale(0.2);
    -ms-transform:scale(0.2);
    transform:scale(0.2);
    transform-origin: top center;
    -webkit-transition: transform 1s; /* Safari */
    transition: transform 1s;
    max-height: 115px;
    z-index: 3;

    @media only screen and (max-width: 768px) {
        -webkit-transform:scale(0.5);
        -moz-transform:scale(0.5);
        -ms-transform:scale(0.5);
        transform:scale(0.5);
    }
}

.demo:hover {
    -webkit-transform:scale(0.8);
    -moz-transform:scale(0.8);
    -ms-transform:scale(0.8);
    transform:scale(0.8);
    @media only screen and (max-width: 768px) {
        -webkit-transform:scale(1);
        -moz-transform:scale(1);
        -ms-transform:scale(1);
        transform:scale(1);
    }
}
</style>